import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'HouseGlassLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: 'daf36083-237f-4abc-b35a-b8c76538bc28',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: -28,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'dd33a16c-811f-4954-a8a5-32234bf1f80a',
      type: 'Armature',
      name: 'item',
      nameSpace: '',
      className: '',
      x: 56,
      y: -50,
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'daf36083-237f-4abc-b35a-b8c76538bc28',
      data: '',
      animationName: 'animtion0',
      armatureName: 'Armature',
      dragonbonesName: 'house_glass',
      playOnStart: true,
      progress: 0,
      playTimes: 0
    }
  ],
  version: '1.0.x'
} as const;

export class HouseGlassLayout {
  static raw = raw;
  root: PIXI.Container
  item: dragonBones.PixiArmatureDisplay

  constructor() {
    populate(this, raw);
  }
}
